module.exports = __webpack_public_path__ + "static/media/11_justice.1a8ed4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/11_justice.png
// module id = 74
// module chunks = 0